<template>
  <div class="table-container-page display-col full-height">
<!--    <div class="breadcrumb-container" v-if="showBreadCrumb=='1'&&canReturn=='0'">-->
<!--&lt;!&ndash;      <BreadCrumb></BreadCrumb>&ndash;&gt;-->
<!--&lt;!&ndash;      <slot name="breadcrumb"></slot>&ndash;&gt;-->
<!--    </div>-->
<!--    <div class="breadcrumb-container editBread-container" v-if="showBreadCrumb=='1'&&canReturn=='1'">-->
<!--&lt;!&ndash;      <slot name="editBreadcrumb"></slot>&ndash;&gt;-->
<!--    </div>-->
    <div class="search-container">
        <slot name="search"></slot>
    </div>
    <div class="table-container flex1">
        <slot name="table"></slot>
    </div>
  </div>
</template>

<script>
import BreadCrumb from './layout/components/breadCrumb'

export default {
  data() {
      return{

      }
  },
  props:{
    canReturn:{
      default:'0'
    },
    showBreadCrumb:{
      default:'1'
    }
  },
  components:{BreadCrumb},
  methods: {
    
  },
  created() {
  }
};
</script>

<style lang="less" scoped>
.table-container-page{
  padding-bottom: 15px;
  // overflow: auto;
}
//.breadcrumb-container{
//  height: 28px;
//}
.search-container{
  // height: 120px;
  background-color: #fff;
  padding: 10px;
}
.table-container{
  margin-top: 10px;
  padding: 10px;
  overflow: hidden;
  background-color: #fff;
}
    
</style>
